/*
  <scrolling-brand-icons>
  -----------------------
  The marquee itself is pure CSS. This element does two small jobs:

    1. Mirrors the CSS :hover pause with pointer events, so the pause also holds
       on devices/browsers where :hover doesn't resolve the way we want.
    2. Keeps the theme editor honest — listeners are bound per instance and torn
       down in disconnectedCallback, so section load/unload can't double-bind.

  No globals, no libraries.
*/
if (!customElements.get('scrolling-brand-icons')) {
  customElements.define(
    'scrolling-brand-icons',
    class ScrollingBrandIcons extends HTMLElement {
      constructor() {
        super();
        this.marquee = null;
        this.onPointerEnter = this.pause.bind(this);
        this.onPointerLeave = this.resume.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      init() {
        // Idempotent: a re-init on an already-bound instance must not stack listeners.
        this.destroy();

        this.marquee = this.querySelector('.scrolling-brand-icons__marquee');
        if (!this.marquee) return;
        if (this.dataset.pauseOnHover !== 'true') return;

        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onPointerEnter);
        this.addEventListener('focusout', this.onPointerLeave);
        this.bound = true;
      }

      destroy() {
        if (!this.bound) return;

        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onPointerEnter);
        this.removeEventListener('focusout', this.onPointerLeave);
        this.bound = false;

        this.resume();
      }

      pause() {
        if (this.marquee) this.marquee.style.animationPlayState = 'paused';
      }

      resume() {
        if (this.marquee) this.marquee.style.animationPlayState = '';
      }
    }
  );

  // Theme editor: re-run setup after a section is re-rendered, tear down before it goes away.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('scrolling-brand-icons').forEach((element) => element.init());
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('scrolling-brand-icons').forEach((element) => element.destroy());
  });
}
